import { trackAction } from 'app/shared/utils/tracking';

import { getNetworkTrackingPropertyGroup } from 'app/dealer/utils';
import { DEALERS_INSIGHTS_TIME_DIVISIONS } from 'app/dealer/shared/modules/dealersInsights/api/dealersInsights.api';
import { PICKER_TRACKING_ACTIONS } from 'app/dealer/shared/components/DummyPicker/DummyPicker';

// DO NOT AUTOFORMAT - our tracking script reads this file

/**
 * @typedef {'increment'|'increment_with_keyboard'|'decrement'|'decrement_with_keyboard'} PickerAction
 */


const { MONTH, YEAR } = DEALERS_INSIGHTS_TIME_DIVISIONS;

/**
 * @typedef {Object} ListingsBenchmarkPickerActionData
 * @property {Object} network
 * @property {'month'|'year'} timeDivision
 * @property {PickerAction} action
 */

/**
 * @param {ListingsBenchmarkPickerActionData} param0
 * @returns {{void}}
 */
export const trackDatePicker = ({
  network,
  selectedTimeDivisionFilter,
  action,
}) => {
  const trackingNetwork = getNetworkTrackingPropertyGroup(network);

  if (selectedTimeDivisionFilter === YEAR) {
    switch (action) {
      case PICKER_TRACKING_ACTIONS.DECREMENT:
        trackAction(
          'dashboard_listings_previous_year_click',
          {
            category: 'dealer_portal',
            description: 'user clicks arrow in filter on top of listings statistics section for navigation to previous year',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.DECREMENT_WITH_KEYBOARD:
        trackAction(
          'dashboard_listings_previous_year_keyboard_arrow_left',
          {
            category: 'dealer_portal',
            description: 'user presses the left arrow on the keyboard for navigation to previous year for listings statistics',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.INCREMENT:
        trackAction(
          'dashboard_listings_next_year_click',
          {
            category: 'dealer_portal',
            description: 'user clicks arrow in filter on top of listings statistics section for navigation to next year',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.INCREMENT_WITH_KEYBOARD:
        trackAction(
          'dashboard_listings_next_year_keyboard_arrow_right',
          {
            category: 'dealer_portal',
            description: 'user presses the right arrow on the keyboard for navigation to next year for listings statistics',
          },
          trackingNetwork,
        );
        break;
      default:
        break;
    }
  }
  if (selectedTimeDivisionFilter === MONTH) {
    switch (action) {
      case PICKER_TRACKING_ACTIONS.DECREMENT:
        trackAction(
          'dashboard_listings_previous_month_click',
          {
            category: 'dealer_portal',
            description: 'user clicks arrow in filter on top of the listings statistics section for navigation to previous month',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.DECREMENT_WITH_KEYBOARD:
        trackAction(
          'dashboard_listings_previous_month_keyboard_arrow_left',
          {
            category: 'dealer_portal',
            description: 'user presses the left arrow on the keyboard for navigation to previous month for listings statistics',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.INCREMENT:
        trackAction(
          'dashboard_listings_next_month_click',
          {
            category: 'dealer_portal',
            description: 'user clicks arrow in filter on top of the listings statistics section for navigation to next month',
          },
          trackingNetwork,
        );
        break;
      case PICKER_TRACKING_ACTIONS.INCREMENT_WITH_KEYBOARD:
        trackAction(
          'dashboard_listings_next_month_keyboard_arrow_right',
          {
            category: 'dealer_portal',
            description: 'user presses the right arrow on the keyboard for navigation to next month for listings statistics',
          },
          trackingNetwork,
        );
        break;
      default:
        break;
    }
  }
};
